<div class="chatbotImage">
  <!-- se lo stato della chat non è close mostro il pallino -->
  <div *ngIf="chatbotStatus === 'minimize'" class="blue-circle"></div>
  <button
    #chatBotButton
    id="chatBotButton"
    type="button"
    class="chatbotIcon"
    [ngClass]="{
      chatbotIconActive: widgetShouldBeShown,
      chatbotClicked: chatbotClicked,
    }"
    [attr.aria-label]="'CHATBOT.ICON_ALT' | translate"
    [attr.aria-expanded]="isChatOpen"
    [attr.aria-controls]="widgetID"
    (click)="toggleChatBot('toggle')"
    (keydown.enter)="toggleChatBot('toggle')"
    (keydown.space)="toggleChatBot('toggle')">
    <img
      src="https://assets.infocert.it/logos/products/trusty/minimized/default.svg"
      alt=""
      aria-hidden="true" />
  </button>
</div>
